// Import and register all your controllers
// This file is auto-generated by bin/generate-controller-index
// Run: node bin/generate-controller-index

import application from "./application";
import AutocompleteController from "./autocomplete_controller";
import BootstrapTableController from "./bootstrap_table_controller";
import ChatAssistantController from "./chat_assistant_controller";
import InvoicesController from "./invoices_controller";
import LookupFiltersController from "./lookup_filters_controller";
import LookupSearchController from "./lookup_search_controller";

// Register controllers
application.register("autocomplete", AutocompleteController);
application.register("bootstrap-table", BootstrapTableController);
application.register("chat-assistant", ChatAssistantController);
application.register("invoices", InvoicesController);
application.register("lookup-filters", LookupFiltersController);
application.register("lookup-search", LookupSearchController);